import { createFileRoute } from "@tanstack/react-router";
import { QaPage, qaJsonLd } from "@/components/QaPage";
import { breadcrumbJsonLd } from "@/lib/seo-jsonld";
import { LAST_REVIEWED } from "@/lib/official-sources";

const QUESTION = "Får jag ha 25-årsgräns på restaurangen?";
const SHORT_ANSWER = "Privat affärsvillkor (åldersgräns för entré eller servering över 18) är tillåtet, så länge det inte är diskriminerande på etnisk grund eller liknande.";

export const Route = createFileRoute("/fraga/ar-25-arsgrans-vid-tveksamhet-laglig")({
  component: () => (
    <QaPage
      breadcrumbs={[
        { label: "Hem", to: "/" },
        { label: "Frågor & svar", to: "/fraga" },
        { label: "Får jag ha 25-årsgräns på restaurangen" },
      ]}
      question={QUESTION}
      shortAnswer={SHORT_ANSWER}
      body={"Många kommuner och branschorganisationer rekommenderar 'när tveksamhet uppstår, kontrollera ID upp till 25 års ålder' för att säkerställa att 18-årsgränsen inte bryts."}
      source={{ label: "Alkohollagen (2010:1622) – Riksdagen", href: "https://www.riksdagen.se/sv/dokument-och-lagar/dokument/svensk-forfattningssamling/alkohollag-20101622_sfs-2010-1622/" }}
      extraSources={[]}
      deepGuide={{ to: "/alkohollagen-kapitel-3", label: "Alkohollagen kap. 3 – åldersgränser" }}
      related={[{"to": "/fraga/far-jag-tillata-egen-medhavd-alkohol", "label": "Får gäster ta med egen alkohol till restaurangen?"}, {"to": "/fraga/far-jag-salja-takeaway-vin-med-mat", "label": "Får jag sälja vin för avhämtning tillsammans med mat?"}, {"to": "/fraga/hur-langt-far-jag-ha-oppet", "label": "Hur länge får jag ha öppet med serveringstillstånd?"}]}
      lastReviewed={LAST_REVIEWED}
    />
  ),
  head: () => ({
    meta: [
      { title: "Får jag ha 25-årsgräns på restaurangen?" },
      { name: "description", content: "Privat affärsvillkor (åldersgräns för entré eller servering över 18) är tillåtet, så länge det inte är diskriminerande på etnisk grund eller liknande." },
      { property: "og:title", content: QUESTION },
      { property: "og:description", content: SHORT_ANSWER },
      { property: "og:url", content: "https://alkoholprovet.se/fraga/ar-25-arsgrans-vid-tveksamhet-laglig" },
    ],
    links: [{ rel: "canonical", href: "https://alkoholprovet.se/fraga/ar-25-arsgrans-vid-tveksamhet-laglig" }],
    scripts: [
      qaJsonLd({
        url: "https://alkoholprovet.se/fraga/ar-25-arsgrans-vid-tveksamhet-laglig",
        question: QUESTION,
        answer: SHORT_ANSWER,
      }),
      breadcrumbJsonLd([
        { label: "Hem", url: "https://alkoholprovet.se/" },
        { label: "Frågor & svar", url: "https://alkoholprovet.se/fraga" },
        { label: "Får jag ha 25-årsgräns på restaurangen", url: "https://alkoholprovet.se/fraga/ar-25-arsgrans-vid-tveksamhet-laglig" },
      ]),
    ],
  }),
});
